import React from "react";

const UserContext = React.createContext(null);
UserContext.displayName = "UserContext";

export default UserContext;
